import React from 'react';
import { Card } from '../components/UI/Card';
export const NetworkingGuide = () => {
  const steps = [{
    number: '1️⃣',
    title: 'Set Your Compass – What Do You Want?',
    content: <div className="space-y-4" data-id="element-4067" data-mp="21mcj4ey1p1na">
          <p data-id="element-4068" data-mp="21ndvqnuplw74">Instead of "I must network more," ask:</p>
          <ul className="space-y-2" data-id="element-4069" data-mp="1xl0uocqwqmgo">
            <li className="flex items-start" data-id="element-4070" data-mp="1xm2fh8xq6nbl">
              <span className="mr-2" data-id="element-4071" data-mp="1xndkfc2wq14a">🔍</span>
              <span data-id="element-4072" data-mp="2ua8dve420jhf">What excites me about connecting with others?</span>
            </li>
            <li className="flex items-start" data-id="element-4073" data-mp="2pbx4f4ho8azq">
              <span className="mr-2" data-id="element-4074" data-mp="2pcypm1seidv6">🎯</span>
              <span data-id="element-4075" data-mp="2kkyk7ttkasr7">
                Am I seeking mentorship, collaboration, opportunities, or just
                inspiration?
              </span>
            </li>
            <li className="flex items-start" data-id="element-4076" data-mp="2gi29sqe6e2yc">
              <span className="mr-2" data-id="element-4077" data-mp="3d2t4eowa6ci2">💎</span>
              <span data-id="element-4078" data-mp="3d3vrelqhfusp">What unique value do I bring into a conversation?</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4079" data-mp="38981ciftysc0">
            <span className="mr-2" data-id="element-4080" data-mp="1yi93oah3n9h">✍️</span>
            <span data-id="element-4081" data-mp="1zjm3yb1ujtu">
              Exercise: Write 3 things you hope to gain from networking — and 3
              things you can give.
            </span>
          </p>
        </div>
  }, {
    number: '2️⃣',
    title: 'Design Your Introduction (Your Story in 30 Seconds)',
    content: <div className="space-y-4" data-id="element-4082" data-mp="3ta1uby44g984">
          <p data-id="element-4083" data-mp="3fcd8amybiw1h">
            Networking starts with clarity. But clarity doesn't mean rigidity.
          </p>
          <ul className="space-y-2" data-id="element-4084" data-mp="3kbpt725mpt1f">
            <li className="flex items-start" data-id="element-4085" data-mp="3kbyad68sbkif">
              <span className="mr-2" data-id="element-4086" data-mp="35dxhym747qt1">👤</span>
              <span data-id="element-4087" data-mp="35f7fnaa22wz5">Who am I? (roles, passions, projects)</span>
            </li>
            <li className="flex items-start" data-id="element-4088" data-mp="3ac7d4wsuaren">
              <span className="mr-2" data-id="element-4089" data-mp="3af39whsyba1i">🌱</span>
              <span data-id="element-4090" data-mp="13mawt19wmq4h">What drives me? (purpose, values, interests)</span>
            </li>
            <li className="flex items-start" data-id="element-4091" data-mp="18ldu1zjn7s1w">
              <span className="mr-2" data-id="element-4092" data-mp="18l41q5b4l8t1">🔗</span>
              <span data-id="element-4093" data-mp="17470qlj8cnn5">Who do I want to connect with right now?</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4094" data-mp="125nboc9cavqk">
            <span className="mr-2" data-id="element-4095" data-mp="123ssp3hmpdp4">🎤</span>
            <span data-id="element-4096" data-mp="x60yg2tihfhr">
              Activity: Draft 2-3 "micro-intros" you can switch between (for
              events, LinkedIn, casual chats).
            </span>
          </p>
        </div>
  }, {
    number: '3️⃣',
    title: 'Choose Your Arena – Where Will You Play?',
    content: <div className="space-y-4" data-id="element-4097" data-mp="1px2lsr7cyhcd">
          <p data-id="element-4098" data-mp="1kvd7n2ou9nk2">Networking happens everywhere:</p>
          <ul className="space-y-2" data-id="element-4099" data-mp="1kwn5prvoyvqp">
            <li className="flex items-start" data-id="element-4100" data-mp="1g4wrvbxjppuj">
              <span className="mr-2" data-id="element-4101" data-mp="1g3lohd80ik3y">🎙</span>
              <span data-id="element-4102" data-mp="1c3jod8hxdyqs">Events & salons</span>
            </li>
            <li className="flex items-start" data-id="element-4103" data-mp="1c31qk7fm7cgr">
              <span className="mr-2" data-id="element-4104" data-mp="28l7ixftif427">📩</span>
              <span data-id="element-4105" data-mp="28n0qcxby5sb9">DMs & email outreach</span>
            </li>
            <li className="flex items-start" data-id="element-4106" data-mp="23u7k250tybx2">
              <span className="mr-2" data-id="element-4107" data-mp="23tg23x05ocp9">🌍</span>
              <span data-id="element-4108" data-mp="3mi0q0wq5inat">Online communities & forums</span>
            </li>
            <li className="flex items-start" data-id="element-4109" data-mp="3mjtxge8l9bjv">
              <span className="mr-2" data-id="element-4110" data-mp="3rhloz75bmvnj">☕</span>
              <span data-id="element-4111" data-mp="3rioh1iedr451">Coffee chats</span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4112" data-mp="3vhe3e0hebw0t">
            <span className="mr-2" data-id="element-4113" data-mp="4bmef4fcupfl">🧭</span>
            <span data-id="element-4114" data-mp="4cns7gnr9q10">
              Prompt: Where do you already feel most comfortable starting? Where
              do you want to stretch yourself?
            </span>
          </p>
        </div>
  }, {
    number: '4️⃣',
    title: 'Practice the First Move',
    content: <div className="space-y-4" data-id="element-4115" data-mp="j08r0ydll334">
          <p data-id="element-4116" data-mp="j222qs32idhz">Instead of waiting for serendipity, design it.</p>
          <ul className="space-y-2" data-id="element-4117" data-mp="n2vobet1fg7p">
            <li data-id="element-4118" data-mp="n1ubb4sgojnc">
              <strong data-id="element-4119" data-mp="n4gih3bfwx51">Warm path:</strong> Ask someone you know for an intro.
            </li>
            <li data-id="element-4120" data-mp="s39xx1aaey7u">
              <strong data-id="element-4121" data-mp="rzm1nudgjxpf">Curious path:</strong> Reach out with a thoughtful
              question.
            </li>
            <li data-id="element-4122" data-mp="jdt5ne8mwsi0">
              <strong data-id="element-4123" data-mp="jdb0tt7wp5yh">Bold path:</strong> DM someone you admire with a specific
              compliment or idea.
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4124" data-mp="ee6r91h2l67m">
            <span className="mr-2" data-id="element-4125" data-mp="t45ngyp2e7kg">💡</span>
            <span data-id="element-4126" data-mp="t2um15j3dbwi">
              Challenge: This week, make 2 connections: one warm intro, one bold
              outreach.
            </span>
          </p>
        </div>
  }, {
    number: '5️⃣',
    title: 'Build Trust, Not Just Contacts',
    content: <div className="space-y-4" data-id="element-4127" data-mp="3rli0xi76ndz3">
          <p data-id="element-4128" data-mp="3rmjmwhpqlkvl">Think about conversations as bridges, not transactions.</p>
          <ul className="space-y-2" data-id="element-4129" data-mp="ado1dcyqma82">
            <li className="flex items-start" data-id="element-4130" data-mp="aepmybddqf41">
              <span className="mr-2" data-id="element-4131" data-mp="5ebc6lke8r2b">👂</span>
              <span data-id="element-4132" data-mp="5cgrn8d1b0yr">Listen deeply.</span>
            </li>
            <li className="flex items-start" data-id="element-4133" data-mp="1ls1mwb60qdkx">
              <span className="mr-2" data-id="element-4134" data-mp="1lqqge3l6urq4">🎁</span>
              <span data-id="element-4135" data-mp="1gtgswthd0q4x">
                Offer something of value (resource, insight, connection).
              </span>
            </li>
            <li className="flex items-start" data-id="element-4136" data-mp="1obodzgjua5ub">
              <span className="mr-2" data-id="element-4137" data-mp="1of2his48ol3c">🔄</span>
              <span data-id="element-4138" data-mp="1tcu9fm4vw77j">
                Follow up quickly with gratitude + a simple next step.
              </span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4139" data-mp="1fe4fgfdd2nne">
            <span className="mr-2" data-id="element-4140" data-mp="1jeo9vb6jvd5u">✨</span>
            <span data-id="element-4141" data-mp="1jfpn9mb1gbqq">
              Reflection: Recall the last time someone made you feel heard. How
              can you replicate that in your networking?
            </span>
          </p>
        </div>
  }, {
    number: '6️⃣',
    title: 'Keep the Web Alive',
    content: <div className="space-y-4" data-id="element-4142" data-mp="1ya471p2ffp6g">
          <p data-id="element-4143" data-mp="1y92vzklev2oq">A network is like a garden — it needs tending.</p>
          <ul className="space-y-2" data-id="element-4144" data-mp="22b68mcjtgdbl">
            <li className="flex items-start" data-id="element-4145" data-mp="22a4n1e56c8fm">
              <span className="mr-2" data-id="element-4146" data-mp="2q10korwb9xus">🌱</span>
              <span data-id="element-4147" data-mp="2pzz0nxxbi10x">Share updates about your journey.</span>
            </li>
            <li className="flex items-start" data-id="element-4148" data-mp="2uucw20bzc85l">
              <span className="mr-2" data-id="element-4149" data-mp="34oifmyk2ne40">🎉</span>
              <span data-id="element-4150" data-mp="34o8p99v474xs">Celebrate others' wins.</span>
            </li>
            <li className="flex items-start" data-id="element-4151" data-mp="30mnebu2550q8">
              <span className="mr-2" data-id="element-4152" data-mp="30nyihuzi0ahv">🔗</span>
              <span data-id="element-4153" data-mp="2vnkm5a79eozo">Connect people to each other.</span>
            </li>
            <li className="flex items-start" data-id="element-4154" data-mp="2vpx3bl570vbo">
              <span className="mr-2" data-id="element-4155" data-mp="2qnxz691mpudo">📒</span>
              <span data-id="element-4156" data-mp="2qrdencz7t5fm">
                Track relationships (Notion, Airtable, CRM, even your Notes
                app).
              </span>
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4157" data-mp="2gxmugka4fh5q">
            <span className="mr-2" data-id="element-4158" data-mp="2cxcm50yuwenp">🛠</span>
            <span data-id="element-4159" data-mp="2cy47liyqow09">
              Action: Create your personal "Connection Tracker" — 5 people to
              re-engage with this month.
            </span>
          </p>
        </div>
  }, {
    number: '7️⃣',
    title: 'Your Rules, Your Rhythm',
    content: <div className="space-y-4" data-id="element-4160" data-mp="1y0loox8qtd0q">
          <p data-id="element-4161" data-mp="1y1mwmsugpje8">
            Forget the idea that networking = constant hustle. It's about
            finding your rhythm:
          </p>
          <ul className="space-y-2" data-id="element-4162" data-mp="1nyrefxylg1ci">
            <li data-id="element-4163" data-mp="1suovk6holbqc">
              <strong data-id="element-4164" data-mp="1sugee2eizk9c">Monthly:</strong> New introductions.
            </li>
            <li data-id="element-4165" data-mp="1xu1isscgsktg">
              <strong data-id="element-4166" data-mp="1xvmbsdj4rvp7">Weekly:</strong> Small touchpoints.
            </li>
            <li data-id="element-4167" data-mp="22te2j481hbrt">
              <strong data-id="element-4168" data-mp="22txmsrl5wc90">Daily:</strong> One authentic conversation.
            </li>
          </ul>
          <p className="font-medium flex items-start" data-id="element-4169" data-mp="156ouodqno4y1">
            <span className="mr-2" data-id="element-4170" data-mp="153sz2w2a5scr">📓</span>
            <span data-id="element-4171" data-mp="1a4774e3vt2as">
              Design Your Rhythm: What feels sustainable and energizing for you?
            </span>
          </p>
        </div>
  }];
  return <div className="pt-20" data-id="element-4172" data-mp="1f20bd1lmjm8f">
      <section className="py-16 bg-secondary/5" data-id="element-4173" data-mp="1jujq41w1snet">
        <div className="container mx-auto px-4" data-id="element-4174" data-mp="1jwcz3nu4vjpz">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-4175" data-mp="mfo001wkivka">
            🌐 The Networking Guide: Build Connections That Matter
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-4176" data-mp="rcea88loywxs">
            This is not a rulebook. It's a playground for you to explore how you
            connect, what feels authentic, and where you want your network to
            take you.
          </p>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto mt-4" data-id="element-4177" data-mp="2fkq0kftrztkn">
            You'll find reflection prompts, mini-experiments, and action
            challenges — designed so you shape your own networking style.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-4178" data-mp="2kj18um4f9w0r">
        <div className="container mx-auto px-4" data-id="element-4179" data-mp="2khzm3ke1nl37">
          <div className="space-y-12" data-id="element-4180" data-mp="2ya61v5dabq24">
            {steps.map((step, index) => <Card key={index} className="p-6 border-2 border-gray-200" data-id="element-4181" data-mp="2ybh5n56qcxt8" data-mpi={index}>
                <div className="flex flex-col md:flex-row md:items-start gap-4" data-id="element-4182" data-mp="2tb37ceuxl28e">
                  <div className="text-3xl font-bold text-primary" data-id="element-4183" data-mp="388vikutg34gs">
                    {step.number}
                  </div>
                  <div className="flex-1" data-id="element-4184" data-mp="33akbgrujb829">
                    <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-4185" data-mp="3mtzp3bh166rf">
                      {step.title}
                    </h2>
                    <div className="text-secondary" data-id="element-4186" data-mp="3qvkxajimdwva">{step.content}</div>
                  </div>
                </div>
              </Card>)}
            <Card className="p-6 border-2 border-gray-200" data-id="element-4187" data-mp="3hvg175ivmkwf">
              <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-4188" data-mp="3htv5hcktsvwz">
                ⚡ Quick Experiments (Choose Your Path)
              </h2>
              <div className="space-y-4" data-id="element-4189" data-mp="37x09p1fxt9me">
                <p className="flex items-start" data-id="element-4190" data-mp="37y1wg36bfkjy">
                  <span className="mr-2 text-xl" data-id="element-4191" data-mp="2u5u5wt5mkptp">🎭</span>
                  <span data-id="element-4192" data-mp="2u7eywecak0pg">
                    <strong data-id="element-4193" data-mp="2u40tex8bzbds">The Actor's Game:</strong> Try introducing yourself
                    3 different ways in one week. Notice what lands.
                  </span>
                </p>
                <p className="flex items-start" data-id="element-4194" data-mp="2k9r1fgnawf3l">
                  <span className="mr-2 text-xl" data-id="element-4195" data-mp="2p70owqr4qgos">📩</span>
                  <span data-id="element-4196" data-mp="2p8lhwbxsprkj">
                    <strong data-id="element-4197" data-mp="1fw2vqmasyyii">The 5-Message Sprint:</strong> Send 5 personalized
                    messages in 5 days. Track replies.
                  </span>
                </p>
                <p className="flex items-start" data-id="element-4198" data-mp="1ktcjzymgh44r">
                  <span className="mr-2 text-xl" data-id="element-4199" data-mp="15zq2tqn30oot">☕</span>
                  <span data-id="element-4200" data-mp="1axj4c6dfwuir">
                    <strong data-id="element-4201" data-mp="1awpyr8q7wb27">The Coffee Challenge:</strong> Book 2 chats with
                    people outside your usual circle this month.
                  </span>
                </p>
              </div>
              <p className="mt-6 font-medium" data-id="element-4202" data-mp="23mggrsuyzx3l">
                👉 By the end of this guide, you don't just "learn how to
                network." You invent your own networking practice — one that
                feels natural, generous, and effective.
              </p>
            </Card>
          </div>
        </div>
      </section>
    </div>;
};